import React from "react";
import Home from "../../components/Home";
import CommonLayout from "../../components/Layouts/CommonLayout";

const HomePage = () => {
  return (
    <CommonLayout>
      <Home />
    </CommonLayout>
  );
};

export default HomePage;
